import { render, staticRenderFns } from "./App.vue?vue&type=template&id=db48b208&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./assets/styles.css?vue&type=style&index=0&id=db48b208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db48b208",
  null
  
)

export default component.exports